var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"SubContentContainer",staticClass:"transparent"},[(_vm.$props.title)?_c('h1',{staticClass:"sub-content-container-title text-center"},[_vm._v(_vm._s(_vm.$props.title))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }